import React from 'react'
import ProjectAccessGuard from '../ProjectAccessGuard'
import APIAccess from '../APIAccess'

const ProjectAccessAPI = () => (
  <ProjectAccessGuard>
    {projectId => <APIAccess projectId={projectId} hideNav />}
  </ProjectAccessGuard>
)

export default ProjectAccessAPI
